var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-module"},[_c('div',{staticClass:"card ticket-card"},[_c('EventGroupItemTicket',{attrs:{"event":_vm.event,"ticket":_vm.ticket}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }